/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "banking": {
        "nested": {
          "BankAccountDetails": {
            "fields": {
              "primaryBankIdentificationNumber": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "accountNumberSuffix": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.banking?.nested?.BankAccountDetails) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE BankAccountDetails @ squareup/banking/instrument_model.proto at 8:1
 */
export const BankAccountDetails = $root.lookupType('squareup.banking.BankAccountDetails');
fixType(BankAccountDetails);
Builder.createAndAttachToType(BankAccountDetails);